import { render } from "./AdPreviewBox.vue?vue&type=template&id=1c50c29c&scoped=true"
import script from "./AdPreviewBox.vue?vue&type=script&lang=js"
export * from "./AdPreviewBox.vue?vue&type=script&lang=js"

import "./AdPreviewBox.vue?vue&type=style&index=0&id=1c50c29c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c50c29c"]])

export default __exports__